import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { GENERAL_HEAL_FLASH_IMAGE_SRC } from '../config/generalHealFlashEffect';
import { getGeneralZoneRect } from '../utils/generalPortraitAnchor';
import './GeneralHealFlashEffect.css';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * heal.png flash centered on the general portrait for 2 seconds.
 */
export function GeneralHealFlashEffect({ generalDataZone, animationKey }) {
  const [anchor, setAnchor] = useState(null);
  const reducedMotion = prefersReducedMotion();

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!generalDataZone) {
        if (!cancelled) setAnchor(null);
        return;
      }
      const rect = getGeneralZoneRect(generalDataZone);
      if (rect) {
        if (!cancelled) {
          const size = Math.min(rect.width, rect.height) * 0.88;
          setAnchor({
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
            size,
          });
        }
        return;
      }
      if (attempt < 24 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setAnchor(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [generalDataZone, animationKey]);

  if (!anchor) {
    return null;
  }

  const layer = (
    <div
      className={[
        'general-heal-flash-layer',
        reducedMotion ? 'general-heal-flash-layer--static' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden
      data-animation-key={animationKey}
    >
      <div
        className="general-heal-flash-root"
        style={{
          left: `${anchor.x}px`,
          top: `${anchor.y}px`,
          width: `${anchor.size}px`,
          height: `${anchor.size}px`,
        }}
      >
        <img
          className="general-heal-flash-img"
          src={GENERAL_HEAL_FLASH_IMAGE_SRC}
          alt=""
          draggable={false}
        />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default GeneralHealFlashEffect;
